import { render, staticRenderFns } from "./LeadTakerIcon.vue?vue&type=template&id=1e6271e5&scoped=true&"
import script from "./LeadTakerIcon.vue?vue&type=script&lang=js&"
export * from "./LeadTakerIcon.vue?vue&type=script&lang=js&"
import style0 from "./LeadTakerIcon.vue?vue&type=style&index=0&id=1e6271e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6271e5",
  null
  
)

export default component.exports